export interface DownloadOption {
  id: string;
  fileName: string;
  label: string;
}

export const DOWNLOAD_FILES: Record<string, DownloadOption> = {
  latestSoftware: {
    id: 'software-1433',
    fileName: 'AOMtrading_1.4.3.3.zip',
    label: 'Download',
  },
  previousSoftware: {
    id: 'software-143',
    fileName: 'AOMtrading_1.4.3.zip',
    label: 'Download',
  },
  latestPremiumSoftware: {
    id: 'software-premium-1433',
    fileName: 'AOMtrading_premium_1.4.3.3.zip',
    label: 'Premium Download',
  },
  previousPremiumSoftware: {
    id: 'software-premium-143',
    fileName: 'AOMtrading_premium_1.4.3.zip',
    label: 'Premium Download',
  },
  latestCharts: {
    id: 'complementary-material',
    fileName: 'ComplementaryStuff_1.4.3.3.zip',
    label: 'Download Complimentary Material',
  },
  previousCharts: {
    id: 'charts-141',
    fileName: 'Chart_templates_1.4.10.zip',
    label: 'Download Chart Templates',
  },
};
